import * as z from "zod/v4";

export const checkCampaignSendWarning = {
  name: "checkCampaignSendWarning" as const,
  input: z.object({ campaignId: z.string() }),
  output: z.object({
    currentRecipientCount: z.number(),
    largestPreviousSend: z.number().nullable(),
  }),
};
